import {ReactNode, useMemo} from "react";
import FiresideSessionPage from "./FiresideSessionPage/FiresideSessionPage";
import Page404 from "./Page404";

const Pages: Record<string, React.FC> = {
  FiresideSession: FiresideSessionPage,
};

interface ContentPaneProps {
  src: string | null;
}

const ContentPane: React.FC<ContentPaneProps> = ({src}) => {
  const [contentElement, contentClass]: [ReactNode, string | undefined] = useMemo(() => {
    if (!src) return [<></>, undefined];
    if (src.indexOf("http") === 0) return [<iframe src={src} title="Content" />, undefined];

    if (src.indexOf("page://") === 0) {
      const compName = src.replace("page://", "");
      const Comp = Pages[compName];
      return [Comp ? <Comp /> : <Page404 />, "Page"];
    }

    return [
      <div className="ImageContainer">
        <div>
          <img src={`/images/${src}`} alt={src} />
        </div>
      </div>,
      undefined,
    ];
  }, [src]);

  return <main className={contentClass}>{contentElement}</main>;
};

export default ContentPane;
